import { useTranslation } from "react-i18next"
import { View, Text, StyleSheet, Image } from "@react-pdf/renderer"

import { styles } from "."

import { dateService } from "services/date"

import { BICYCODE_ID } from "operators/bicycode/config"
import { OperatorInterface } from "utils"
import { DECATHLON_ID } from "operators/decathlon/config"
import { MFC_ID } from "operators/mfc/config"

type PDFHeaderProps = {
	currentOperator: OperatorInterface
}

export const PDFHeader = ({ currentOperator }: PDFHeaderProps) => {
	const { t } = useTranslation()

	const headerStyles = StyleSheet.create({
		header: {
			flexDirection: "row",
			alignItems: "center",
			justifyContent: "space-between",
		},
		leftColumn: {
			width: 220,
			marginLeft: "auto",
		},
	})

	const mainUrl =
		process.env.REACT_APP_MODE === "production"
			? `${window.location.origin}`
			: `${process.env.PUBLIC_URL}`

	return (
		<View style={headerStyles.header}>
			<View style={headerStyles.leftColumn}>
				{currentOperator.id === BICYCODE_ID && (
					<Image style={[styles.image]} src={`${mainUrl}/BicyCode-logoBleu.jpg`} />
				)}

				{currentOperator.id === DECATHLON_ID && (
					<Image style={[styles.image]} src={`${mainUrl}/logo_decathlon.jpg`} />
				)}

				{currentOperator.id === MFC_ID && (
					<Image style={[styles.image]} src={`${mainUrl}/MFC_logo.jpg`} />
				)}

				<Text style={[styles.p]}>
					{t("pdf.date", {
						ns: "bike",
						date: dateService.formatDate(new Date(), "dd/MM/y"),
					})}
					,
				</Text>
			</View>
		</View>
	)
}
